/**
 * All suffixes created or modified here should reflect in the docs/ERROR_CODES.md documentation.
 *
 * {@link https://github.azc.ext.hp.com/jarvis/react-portal-oobe-mfe/blob/develop/ERROR_CODES.md}
 */

import { ValueOfUnion } from 'ramda'

import { ApiPrefix } from './prefix'

/**
 * Page suffixes to identify the specific page or feature related to the error.
 * The `XX` is a reserved suffix for unexpected errors.
 */
export enum PageSuffix {
  PORTAL_VALUE_PROP = 'PV',
  CLOUD_VALUE_PROP = 'CV',
  APP_VALUE_PROP = 'AV',
  APP_GEN2_VALUE_PROP = 'GT',
  FIRMWARE_UPDATE_NOTICE = 'FN',
  FIRMWARE_UPDATE_CHOICE = 'FC',
  HARDWARE_STATUS_CHECK = 'SC',
  HP_ALL_IN = 'HA',
  PAIRING_CODE = 'PC',
  PRINTER_ACTIVATION = 'PA',
  RETAILER_REFURB = 'RR',
  HP_PLUS_REQUIREMENTS = 'HR',
  PRINTER_NAME_AND_LOC = 'NL',
  PORTAL_HANDOFF = 'PH',
  ASSIGN_WORKSPACE = 'AW',
  ASSIGN_ORGANIZATION = 'AO',
  HP_PLUS_SAFETY_NET = 'HS',
  HP_PLUS_CALL_SUPPORT = 'HC',
  HP_ALL_IN_NO_ACCOUNT = 'HN',
  HP_ALL_IN_WRONG_ACCOUNT = 'HW',
}

/**
 * Device HTTP Proxy (DHP) service suffixes to identify the specific service related to the error.
 * The `XX` is a reserved suffix for unexpected errors.
 */
export enum DHPServiceSuffix {
  GET_CARTRIDGE_TYPE = 'CT',
  GET_DEVICE_SETUP = 'DS',
  SET_FWU_CHOICE = 'FC',
  SET_FWU_ACTION = 'FA',
  GET_PRINTER_FINGERPRINT = 'PF',
  GET_CLAIM_POSTCARD = 'CP',
}

/**
 * API prefixes to identify the source of the error.
 * This constant should reflect the api prefixes defined on {@link API_PREFIX}
 */
export const APIS_SUFFIX = {
  DA: {
    VERIFY: 'VP',
  },
  AM: {
    REGISTER_DEVICE: 'RD',
    VALIDATE_DEVICE: 'VD',
    CREATE_ACCOUNT: 'CA',
  },
  SM: {
    SCAN_TO_EMAIL: 'SE',
  },
} as const satisfies Record<ApiPrefix, Record<string, string>>
export type ApisSuffix = typeof APIS_SUFFIX

/**
 * Union type of all API suffixes.
 */
export type ApiSuffix = ValueOfUnion<ApisSuffix[keyof ApisSuffix]>
